class PaymentFormRequestParameter {
	readonly key: string;
	readonly value: string;

	constructor(key: string, value: string) {
		this.key = key;
		this.value = value;
	}
}

export class PaymentGatewayFormRequest {
	readonly orderId?: string;
	readonly gateway?: string;
	readonly urlApiBase?: string;
	params?: PaymentFormRequestParameter[];

	constructor(orderId: string, gateway: string, urlApiBase: string) {
		this.orderId = orderId;
		this.gateway = gateway;
		this.urlApiBase = urlApiBase;
	}

	setParameter(key: string, value: string): void {
		if (!this.params) {
			this.params = [];
		}

		const parameter = new PaymentFormRequestParameter(key, value);
		this.params.push(parameter);
	}
}
